import type { NextPage } from 'next';
import { useRouter } from 'next/router';
import { useGlobal } from '@/utils/useGlobal';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import ProtablePowerStationQuestion from '@/components/ProtablePowerStationQuestionnaire';

const ProtablePowerStationQuestionnaire: NextPage = ({ SEO }: any) => {
    const { useEffect, useLang } = useGlobal();
    const { t } = useLang('questionnaire');
    const router = useRouter();
    const { locale } = router;

    useEffect(() => {
        // 仅限us
        if (!['us'].includes(locale as string)) {
            router.push('/404');
        }
    }, []);
    return (
        <>
            <SEO title={t('seo.title')} description={t('seo.desc')}></SEO>
            <SEOlinksA list={['us']} pathname={'delta-3-portable-power-station-questionnaire'} locale={String(locale)}></SEOlinksA>
            <PageLayout>
                <div>
                    <ProtablePowerStationQuestion />
                </div>
            </PageLayout>
        </>
    );
};

export default ProtablePowerStationQuestionnaire;
